module.exports = __webpack_public_path__ + "media/images/team/dodjie-encinas-d7d3c57e075e2b03fa1be443bf0c8855.png";